import React from 'react';
import { useT } from '@repo/common';
import { ReactComponent as CheckIcon } from '@repo/common/assets/icons/20px/icon_20px_check.svg';

/**
 * 지원 시 필요한 것. 이력서·포트폴리오 둘 다 필요 없으면 Koready 프로필로 바로 지원한다는 안내로 대체.
 */
const ApplicationRequirements = ({ job }) => {
  const t = useT();
  const resumeRequired = Boolean(job?.resumeRequired);
  const portfolioRequired = Boolean(job?.portfolioSubmission);

  const items = [
    resumeRequired && t('Resume', '이력서'),
    portfolioRequired && t('Portfolio', '포트폴리오'),
  ].filter(Boolean);

  return (
    <div>
      <div className='flex flex-col items-start py-[30px] w-full gap-2 tabletH:gap-4 text-text-primary'>
        <div className='typo-b18Strong self-stretch'>
          {t('Application requirements', '지원 시 제출 서류')}
        </div>

        {items.length === 0 ? (
          <div className='flex flex-col gap-1'>
            <p className='typo-b14Strong'>
              {t('Apply with your Koready profile', 'Koready 프로필로 바로 지원')}
            </p>
            <p className='typo-b14 text-text-secondary'>
              {t(
                'No resume or portfolio needed — your Koready profile is sent as your application.',
                '이력서나 포트폴리오 없이 Koready 프로필이 지원서로 전달됩니다.',
              )}
            </p>
          </div>
        ) : (
          <ul className='flex flex-col gap-2'>
            {items.map((item) => (
              <li key={item} className='flex items-center gap-2 typo-b14'>
                <CheckIcon className='text-icon-success shrink-0' />
                <span>{item}</span>
                <span className='typo-b12 text-text-secondary'>
                  · {t('Required', '필수')}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className='border-b border-grayscale-gray02' />
    </div>
  );
};

export default ApplicationRequirements;
